import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Badge,
  useColorModeValue,
} from "@chakra-ui/react";

interface CheatsheetCard {
  title: string;
  description: string;
  path: string;
  tags: string[];
  status: "ready" | "wip";
}

const cheatsheets: CheatsheetCard[] = [
  {
    title: "Local PVM Debug Setup",
    description: "Run a local sync node + PVM with VSCode breakpoints. Covers state sync, app.toml config, and the full debug workflow for Lucas.",
    path: "/cheatsheets/local-pvm-debug",
    tags: ["pokerchain", "pvm", "debugging", "cosmos"],
    status: "ready",
  },
];

const CheatsheetIndex: React.FC = () => {
  const cardBg = useColorModeValue("white", "gray.800");
  const cardBorder = useColorModeValue("gray.200", "gray.600");
  const hoverBg = useColorModeValue("blue.50", "blue.900");

  return (
    <Container maxW="container.lg" py={8}>
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="xl" mb={2}>Developer Cheatsheets</Heading>
          <Text color="gray.600">
            Quick-reference guides for Block52 development workflows
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {cheatsheets.map((sheet) => (
            <Box
              key={sheet.path}
              as={RouterLink}
              to={sheet.path}
              p={5}
              bg={cardBg}
              borderWidth="1px"
              borderColor={cardBorder}
              borderRadius="lg"
              _hover={{ bg: hoverBg, borderColor: "blue.300", transform: "translateY(-2px)" }}
              transition="all 0.2s"
              cursor="pointer"
              textDecoration="none"
              display="block"
            >
              <VStack align="start" spacing={2}>
                <Heading size="md">{sheet.title}</Heading>
                {sheet.status === "wip" && (
                  <Badge colorScheme="yellow">Work in Progress</Badge>
                )}
                <Text fontSize="sm" color="gray.600">{sheet.description}</Text>
                <Box>
                  {sheet.tags.map((tag) => (
                    <Badge key={tag} colorScheme="blue" mr={1} mb={1} fontSize="xs">
                      {tag}
                    </Badge>
                  ))}
                </Box>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>

        <Box textAlign="center" pt={4}>
          <Text fontSize="sm" color="gray.400">
            Block52 Developer Cheatsheets
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default CheatsheetIndex;
